import BaseModel from '../base/BaseModel.model';
import Tag from './tag.model';
import Record from './record.model';

export default class RecordHistory  {


    public name?: string; 
    public url?: string; 
    public id?: number; 
    
    constructor() {
        this.init();
    }

    init() {
        this.id = 0;
        this.name = '';
        this.url = '';
    }
}